module.exports = __webpack_public_path__ + "media/images/icon-share-off@3x-5a6af7fd7217763c821fff15adc697f1.png";